/**
 * 📊 لوحة الأداء.
 *
 * ⛔ **مفيش أي مسار بيجيب صورة شاشة ولا محتوى** — ولا هيبقى فيه. السبب
 *    الحاكم مكتوب في `backend/app/services/performance.py`.
 */
import { ApiError, api } from "./client";

export type PerfOutcomes = {
  closed: number;
  open_now: number;
  overdue_now: number;
  /** ⚠️ `null` = مفيش مهمة مقفولة نقيس عليها — **مش** صفر دقيقة */
  avg_claim_to_close_minutes: number | null;
  measured_on: number;
};

export type PerfSpan = {
  first_action_at: string | null;
  last_action_at: string | null;
  actions: number;
};

export type PerfSnapshot = {
  day: string;
  days_window: number;
  active_minutes_today: number;
  active_minutes_by_day: Record<string, number>;
  active_minutes_total: number;
  span_today: PerfSpan;
  outcomes: PerfOutcomes;
};

export type PerfRow = PerfSnapshot & {
  user_id: string;
  name_ar: string;
  department: string | null;
};

export async function fetchMyPerformance(
  days: number,
  signal?: AbortSignal,
): Promise<PerfSnapshot> {
  const path = "/performance/me";
  const res = await api.get<PerfSnapshot>(path, { query: { days }, signal });
  if (!res.data) {
    // ⚠️ رد ناجح بجسم فاضي مش نجاح — الشاشة كانت هترسم أصفارًا كأنها حقيقة
    throw new ApiError(
      500,
      { code: "NO_DATA", message_ar: "مقدرناش نجيب أرقام الأداء دلوقتي" },
      null,
    );
  }
  return res.data;
}

export async function fetchTeamPerformance(
  days: number,
  signal?: AbortSignal,
): Promise<PerfRow[]> {
  const res = await api.get<PerfRow[]>("/performance/team", { query: { days }, signal });
  return res.data ?? [];
}

/** «٣ ساعات و٢٠ دقيقة» — ⛔ أرقام لاتينية زي باقي السيستم */
export function minutesLabelAr(total: number): string {
  if (total <= 0) return "مفيش نشاط";
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (h === 0) return `${m} دقيقة`;
  if (m === 0) return h === 1 ? "ساعة" : h === 2 ? "ساعتين" : `${h} ساعات`;
  const hp = h === 1 ? "ساعة" : h === 2 ? "ساعتين" : `${h} ساعات`;
  return `${hp} و${m} دقيقة`;
}
